export default __webpack_public_path__ + "static/media/settings.6b7664a0.svg";